export default __webpack_public_path__ + "static/media/bg-bursa-dark.da31f3c2.png";